








































import { Vue, Component, Prop } from "vue-property-decorator";
import SignUpText from "../SignUp/SignUpText.vue";
import { bus } from "../../main";
import * as auth from "../../_store/auth.module";
import * as user from "../../_store/user.module";
// import { UserInfo } from '../_models/userInfo'
import { EnterpriseSignUpInfo } from "../../_models/enterpriseSignUpInfo";

@Component({
  components: {
    SignUpText
  }
})
export default class PrivacyDialog extends Vue {
  @Prop() selector!: string;
  @Prop() status!: string;
  private dialog: boolean;
  private enterprise: EnterpriseSignUpInfo;

  constructor() {
    super();
    this.dialog = false;
    this.enterprise = {
      denominazione: "",
      pIva: "",
      telefono: "",
      emailAzienda: "",
      password: "",
      token: ""
    };
  }

  signUp() {
    auth.dispatchSignUp(this["$store"], this.enterprise).then(() => {});
  }

  close() {
    this.dialog = false;
  }

  parseToken(token: string): JSON {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function(c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }

  accept() {
    var localToken: string | null = localStorage.getItem("userToken");
    var parsedToken: any;
    if (localToken !== null) {
      parsedToken = this.parseToken(localToken);
    }
    var tokenInfo = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    auth
      .dispatchChangeStatus(this["$store"], tokenInfo.username)
      .then(() => {
        this.dialog = false;
        localStorage.removeItem("userStatus")
        // bus.$emit("incompleteInfo");
        bus.$emit("openWelcomeDialog")
      })
      .catch(error => {
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/login");
      });
  }

  refuse() {
    user.dispatchClearState(this["$store"]);
    auth.dispatchLogout(this["$store"]).then(() => {
      this["$router"].push("/login");
      localStorage.removeItem("userStatus")
    });
  }

  created() {
    if(this.status === '5'){
      this.dialog = true
    }
    bus.$on("signUp", (payload: EnterpriseSignUpInfo) => {
      this.dialog = true;
      this.enterprise = payload;
    });

    // bus.$on("loggedIn", (status:string) =>{
    //   console.log(status)
    //   this.dialog = true;
    // })
  }
}
